<template>
	<div id="UIFilters">
		
        <div class="UI_items layers">

			<div v-for="(layer, indexLayer) in okanMap.layers" v-bind:key="indexLayer"
			v-bind:class="{
				['UI_item layer'] : true,
				['open'] : true
			}"
			v-show="layer.visible"
			>

                <div
				v-bind:class="{
					['UI_item_header'] : true,
					['open'] : true
				}">

                    <div class="UI_item_header_title">
						<span  >
							{{layer.name}}
						</span>
					</div>

                </div>

                <div class="UI_item_filter">
                    <div v-for="(property, indexProperty) in getProperties(layer)"
                    v-bind:key="indexProperty"
					v-show="property.type != 'string' && property.min != property.max">

						<div
						v-bind:class="{
							['UI_item_filter_header'] : true,
							['enabled'] : getProperty(layer, indexProperty).filter.enabled
						}">
							<h4 v-on:click="
							getProperty(layer, indexProperty).filter.enabled = !getProperty(layer, indexProperty).filter.enabled; 
							addFilter(property);
							okanMap.setLayerFilters(layer)
							"
							>{{property.name}}</h4>
						</div>
						
						<FilterSlider v-show="getProperty(layer, indexProperty).filter.enabled" 
						v-bind:okanMap="okanMap" 
						v-bind:idProp="indexProperty"
						v-bind:layer="layer" 
						v-on:FilterUpdate="filterUpdate"/>
                    </div>
                </div>


			</div>


        </div>
        
	</div>
</template>

<script>
import FilterSlider from '../components/ui/filterSlider.vue'

export default {
	name: 'UIFilters',
	components: {
		FilterSlider
	},
	props: {
		okanMap : Object
	},
	data: function() {
		return {

			

		}
	},
	mounted() {

	},
	created() {

	},
	destroyed() {

	},
	methods : {

		init() {
		},

		filterUpdate(filterParams) {

			//console.log(filterParams);
			
			this.getProperty(filterParams.layer, filterParams.indexProperty).filter.min = filterParams.min;
			this.getProperty(filterParams.layer, filterParams.indexProperty).filter.max = filterParams.max;
			//filterParams.property.filter.max = filterParams.max;
			//filterParams.property.filter.max = filterParams.min;

			//console.log(filterParams.min)

			this.okanMap.setLayerFilters(filterParams.layer)

			//console.log(this.okanMap.sources)
		},
		
		getSource(layer) {
			return this.okanMap.sources[layer.sourceIndex]
		},

		getProperty(layer, indexProperty) {
			return this.getSource(layer).properties[indexProperty];
		},
        
        getProperties(layer){
			//return this.okanMap.getSourceProperties( this.okanMap.sources[layer.sourceIndex]).filter(x => x.type != 'string' && x.min != x.max);
			return this.okanMap.getSourceProperties( this.okanMap.sources[layer.sourceIndex]);
		},
		
		addFilter(property, e = null) {
			//console.log(e)
			//console.log(property)
		}

	}
}
</script>

<style scoped src="../assets/css/ui.css"></style>